import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const AiMl = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>AI/ML Solutions</h1>
      <p>Smart AI systems for automation, optimization, and next-gen product intelligence.</p>
      <ul className="bullet-points">
        <li>🔍 OCR & Computer Vision</li>
        <li>🤖 Chatbots & NLP models</li>
        <li>📈 Predictive analytics</li>
        <li>🧠 Model training & fine-tuning</li>
      </ul>
    </div>
  </motion.div>
);

export default AiMl;
